/* eslint-disable camelcase */
import { DadataBankResponse } from '../../../structures/response/dadata/DadataBankResponse';
import { RegisterCreateRequest } from '../../../structures/request/RegisterCreateRequest';

export function dadataBankResponseToCreateRequest(
  { name, address, bic, correspondent_account }: DadataBankResponse,
  title = '',
  number = ''
): RegisterCreateRequest {
  return {
    bankName: name?.full || name?.payment,
    address: address?.value,
    bik: bic,
    correspondent: correspondent_account,
    title,
    number,
  };
}
